import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=363dc7a5&scoped=true&lang=pug&"
import script from "./tabs.vue?vue&type=script&lang=ts&"
export * from "./tabs.vue?vue&type=script&lang=ts&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=363dc7a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363dc7a5",
  null
  
)

export default component.exports